const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/venues/$id.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { getFindAllVenueOverviewVersionsQueryOptions, getFindAllVenueRentalVersionsQueryOptions, getFindVenueQueryOptions, mapVenueOverviewVersionsResponseType, mapVenueRentalVersionDatesResponseType } from '@api';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { t } from 'i18next';
export const Route = createFileRoute('/_rootLayout/venues/$id')({
  beforeLoad: async ({
    params,
    matches,
    context: {
      queryClient
    }
  }) => {
    const lastMatch = matches[matches.length - 1];
    if (lastMatch.id.endsWith(`/venues/${params.id}`)) {
      redirect({
        to: '/venues/$id/general',
        params: {
          id: params.id
        },
        throw: true,
        replace: true
      });
    }
    const [overviewVersionsData, rentalVersionsData] = await Promise.all([queryClient.ensureQueryData(getFindAllVenueOverviewVersionsQueryOptions(params.id)), queryClient.ensureQueryData(getFindAllVenueRentalVersionsQueryOptions(params.id))]);
    const overviewVersions = mapVenueOverviewVersionsResponseType(overviewVersionsData);
    const rentalVersionDates = mapVenueRentalVersionDatesResponseType(rentalVersionsData);
    return {
      overviewVersions,
      rentalVersionDates
    };
  },
  loader: async ({
    context: {
      queryClient
    },
    params
  }) => {
    queryClient.ensureQueryData(getFindVenueQueryOptions(params.id));
    return {
      crumb: t('NAVIGATION.VENUES'),
      to: '/venues'
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});